import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=3f7c8a33&scoped=true"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=3f7c8a33&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7c8a33",
  null
  
)

export default component.exports